(function() {
	'use strict';
	
	angular.module('vhols-maps').directive('hotelLinkBrowse', ['$interpolate', function($interpolate) {

        var hotelBrowse = $interpolate('/destinations{{path}}-browse');

        return {
            restrict: 'A',
            scope: {
                hotelLinkBrowse: '='
            },
            link: function($scope, $element) {

                if ($scope.hotelLinkBrowse) {
                    update($scope.hotelLinkBrowse);
                }

                $scope.$on('$destroy', $scope.$watch('hotelLinkBrowse', function (hotel) {
                    if (hotel) {
                        update(hotel);
                    }
                }));

                function update(hotel) {
                    $element.attr('href', hotelBrowse({
                        path: hotel.content.url
                    }));
                }
            }
        };
    }]);
})();